module.exports = __webpack_public_path__ + "9d6fe3596b91a5ac5ee37067f452091a.pdf";